"use client";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import Image from "next/image";
import React from "react";
import SalonTymCoin from "../../assets/salon_tym_coin.jpg";
import { Loader } from "../genericComponents/MainLoader/Loader";
import Link from "next/link";
import { ApiService } from "@/app/services/AppService";

export const SalonTymCoinsVisit = () => {
  const [loading, setLoading] = React.useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleNavigate = () => {
    setLoading(true);
  };

  const apiService = new ApiService();

  return (
    <>
      {loading && <Loader />}
      <Box
        sx={{
          width: "100%",
          textAlign: "center",
          background: "#fff",
          height: "auto",
          marginTop: "3rem",
        }}
      >
        <Link
          prefetch={false}
          href={"/store"}
          passHref
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleNavigate}
        >
          {" "}
          <Image
            src={SalonTymCoin}
            width={3000}
            height={1000}
            style={{
              margin: "auto",
              objectFit: "cover",
              width: isSmallScreen ? "100%" : "50%",
              height: "auto",
              cursor: "pointer",
            }}
            alt="category"
          />
        </Link>
      </Box>
    </>
  );
};
